export const getClassNameForSubRow = (isSubRow: boolean): string => {
    return isSubRow ? "sub-row" : "";
};

export const getCellColor = ({
    color,
    isProjected,
}: {
    color?: string;
    isProjected?: boolean;
}): string => (color ? color : isProjected ? "flexidaoGrey.6" : "flexidaoGrey.9");
